// extracted by mini-css-extract-plugin
export var compact = "_mw-2";
export var phoneFrame = "_mw-0";
export var phoneScreen = "_mw-1";